var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 642,
    height: 75.404,
    viewBox: "0 0 642 75.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mentor\\xEDa_financiera",
    "data-name": "Mentor\\xEDa financiera",
    transform: "translate(0 3.202)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Mentor\\xEDa_financiera_",
    "data-name": "Mentor\\xEDa financiera ",
    transform: "translate(330 48.5)",
    fill: "#303030",
    fontSize: 33,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mentor\xEDa financiera ")), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_9427",
    "data-name": "L\\xEDnea 9427",
    x1: 25,
    y2: 69,
    transform: "translate(286)",
    fill: "none",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19618",
    "data-name": "Grupo 19618",
    transform: "translate(-467.986 -4984.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Principal",
    transform: "translate(467.986 4996.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18098",
    "data-name": "Grupo 18098",
    transform: "translate(6.107 0.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39776",
    "data-name": "Trazado 39776",
    d: "M404.964,1527.568a16.147,16.147,0,0,1-11.423-27.574,3.7,3.7,0,0,1,5.233,5.223,8.781,8.781,0,1,0,6.782-2.538,3.705,3.705,0,1,1,.48-7.395,16.159,16.159,0,0,1-1.058,32.284Z",
    transform: "translate(-357.547 -1484.177)",
    fill: "#ee2b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39777",
    "data-name": "Trazado 39777",
    d: "M376.288,1495.783c7.073,0,12.358,4,12.358,7.95,0,2.431-1.8,3.647-3.94,3.647-4,0-2.554-4.983-8.643-4.983-3.3,0-7.2,2.257-7.2,9.909,0,5.289,2.493,8.708,7.132,8.708,5.915,0,4.648-5.446,9.109-5.446a3.344,3.344,0,0,1,3.541,3.236c0,3.72-4.171,8.822-12.879,8.822-10.445,0-15.366-6.425-15.365-15.32,0-9.735,5.506-16.524,15.885-16.524",
    transform: "translate(-360.403 -1484.126)",
    fill: "#ee2b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39778",
    "data-name": "Trazado 39778",
    d: "M422.421,1500.009c0-2.539,1.521-4.226,4.016-4.226s3.994,1.687,3.994,4.226v1.114h.125a11.894,11.894,0,0,1,10.2-5.34,8.446,8.446,0,0,1,8.128,5.34c2.368-3.317,5.389-5.34,9.968-5.34,5.865,0,10.565,2.667,10.565,10.268v17.339c0,2.264-.929,4.236-4.231,4.236s-4.245-1.972-4.245-4.236V1508.2c0-3.031-1.315-5.459-4.632-5.459a6.259,6.259,0,0,0-6.148,6.562v14.091c0,2.264-.934,4.236-4.237,4.236s-4.238-1.972-4.238-4.236V1508.2c0-3.031-1.336-5.459-4.632-5.459a6.262,6.262,0,0,0-6.153,6.562v14.091c0,2.264-.929,4.236-4.24,4.236-3.294,0-4.237-1.972-4.237-4.236Z",
    transform: "translate(-354.167 -1484.126)",
    fill: "#ee2b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39779",
    "data-name": "Trazado 39779",
    d: "M474.144,1503.166h-1.917c-2.382,0-3.369-.921-3.369-2.783s.987-2.785,3.37-2.785h1.916v-4.229c0-5.34,4.4-8.177,9.331-8.177,3.083,0,5.576,1.222,5.576,4.063a2.84,2.84,0,0,1-2.734,2.9c-.632,0-1.216-.168-1.854-.168a1.768,1.768,0,0,0-1.855,1.967v3.649h2.612c2.494,0,3.832.759,3.832,2.785,0,2.043-1.339,2.783-3.832,2.783h-2.613v21.289a4.231,4.231,0,1,1-8.462,0Z",
    transform: "translate(-349.498 -1485.191)",
    fill: "#ee2b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39780",
    "data-name": "Trazado 39780",
    d: "M519.479,1500.009c0-2.538,1.514-4.226,4.009-4.226s4,1.688,4,4.226v1.114h.111a11.94,11.94,0,0,1,10.214-5.34,8.46,8.46,0,0,1,8.122,5.34,11.493,11.493,0,0,1,9.982-5.34c5.858,0,10.558,2.667,10.558,10.268v17.339c0,2.264-.939,4.236-4.242,4.236S558,1525.654,558,1523.39v-15.2c0-3.03-1.333-5.458-4.65-5.458a6.264,6.264,0,0,0-6.147,6.562v14.091c0,2.264-.912,4.237-4.223,4.237s-4.246-1.973-4.246-4.237v-15.2c0-3.03-1.336-5.458-4.639-5.458a6.26,6.26,0,0,0-6.147,6.562v14.091c0,2.264-.929,4.237-4.242,4.237s-4.229-1.973-4.229-4.236Z",
    transform: "translate(-344.408 -1484.126)",
    fill: "#ee2b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39781",
    "data-name": "Trazado 39781",
    d: "M591.167,1525.278l-9.02-18.016-6.43,12.885h7.848a3.542,3.542,0,1,1,0,7.083h-13.56a3.551,3.551,0,0,1-3.166-5.124l12.147-24.325a3.531,3.531,0,0,1,6.309,0l12.188,24.325h.014a3.529,3.529,0,0,1-1.587,4.738,3.429,3.429,0,0,1-1.58.386,3.55,3.55,0,0,1-3.163-1.953",
    transform: "translate(-339.682 -1484.121)",
    fill: "#ee2b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39782",
    "data-name": "Trazado 39782",
    d: "M490.165,1527.231a3.539,3.539,0,0,1-3.155-5.123l6.785-13.547a3.536,3.536,0,0,1,6.317,3.177l-4.222,8.411h12.893l-9.585-19.2a3.535,3.535,0,1,1,6.318-3.17l12.128,24.327a3.5,3.5,0,0,1-.146,3.439,3.548,3.548,0,0,1-3,1.684Z",
    transform: "translate(-347.71 -1484.121)",
    fill: "#ee2b7b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86207",
    "data-name": "Rect\\xE1ngulo 86207",
    width: 264.295,
    height: 44,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d3d52a507753602d93b544cd27a917a6.svg";
export { ForwardRef as ReactComponent };